<template>
  <v-dialog v-model="dialog" persistent max-width="800px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn fab dark large class="mx-2" elevation="4"  color="primary" v-bind="attrs" v-on="on">
        <v-icon large>add_business</v-icon></v-btn>
    </template>
    <template>
      <v-card>

        <v-toolbar color="primary" dark>
          <v-toolbar-title>
          <v-toolbar-items>Cadastrar Órgao</v-toolbar-items>
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn class="mx-2" icon>
              <v-icon dark large @click="dialog = false">cancel</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        
        <v-card-text>
        <cadastroOrgao v-if="dialog" />
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="dialog = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import cadastroOrgao from "./cadastroOrgao";
export default {
  name: "modalCadastrOrgao",
  components: { cadastroOrgao },
  data: function() {
    return {
      dialog: false,
    };
  },
};
</script>
<style>
</style>
